

<div *ngFor="let screenOpt of CurrentScreen.ScreenOptions" class="CPQScreen">
  <span [hidden]="!screenOpt.IsVisible" class="ScreenDesc" [innerHTML]="CurrentScreen.Description"></span>
  <app-cpqscreen-options [CurrentScreenOption]="screenOpt" [Description]="CurrentScreen.Description" [hidden]="!screenOpt.IsVisible" (handleValueChange)="OnScreenOptionChange($event)" (handleInvalidEmitter)="OnInvalidEmitter($event)"></app-cpqscreen-options>

</div>
